import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllExportTasksThunk } from 'components/pages/export/thunk/exportTaskThunk';
import { PAGINATION } from 'utils/constants';
import { SCREEN_TYPE } from 'utils/enums';

const _paginateDefault: Pagination = {
    page: 1,
    per_page: PAGINATION.LIMIT_PER_PAGE,
    total: 0,
    total_pages: 0,
};

const initialState: ExportTaskState = {
    // Detail
    // formRegister: undefined,
    // dataTableInput: [],
    // selectedItemInput: undefined,
    // selectedItemsInput: [],
    // dataTableOutput: [],
    // selectedItemOutput: undefined,
    // selectedItemsOutput: [],
    // dataDeletedOutput: [],
    // dataDeletedInput: [],
    // List
    dataTable: [],
    paginateMetaData: _paginateDefault,
    sort: {
        ascending: true,
        fieldName: 'task_id',
        sortColumn: -1,
    },
    selectedItem: undefined,
    selectedItems: [],
    // Common
    isDetailLayout: false,
    isShowDeleteButton: false,
    formSearch: undefined,
    screenMode: SCREEN_TYPE.list,
    getKeywords: [],
};

export const exportTaskSlice = createSlice({
    name: 'exportTask',
    initialState,
    reducers: {
        // Detail
        // List
        setDataTable: (state, action: PayloadAction<TExportTask[]>) => {
            state.dataTable = action.payload;
        },
        setSort: (state, action: PayloadAction<SortState | undefined>) => {
            state.sort = action.payload;
        },
        setPaginateMetaData: (state, action: PayloadAction<Pagination>) => {
            state.paginateMetaData = action.payload;
        },
        setSelectedItem: (state, action: PayloadAction<TExportTask | undefined>) => {
            state.selectedItem = action.payload;
        },
        setSelectedItems: (state, action: PayloadAction<number[]>) => {
            state.selectedItems = action.payload;
        },
        // Common
        setDetailLayout: (state, action: PayloadAction<boolean>) => {
            state.isDetailLayout = action.payload;
        },
        setShowDeleteButton: (state, action: PayloadAction<boolean>) => {
            state.isShowDeleteButton = action.payload;
        },
        setFormSearch: (state, action: PayloadAction<ExportTaskSearch>) => {
            state.formSearch = action.payload;
        },
        handleBackProcessingTask: (state) => {
            state.isDetailLayout = false;
        },
        setMode: (state, action: PayloadAction<SCREEN_TYPE>) => {
            state.screenMode = action.payload;
        },
        setKeywords: (state, action: PayloadAction<string[]>) => {
            state.getKeywords = action.payload;
        },
        resetExportTaskState: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(getAllExportTasksThunk.fulfilled, (state, action) => {
            state.dataTable = action.payload.data ?? [];
            state.paginateMetaData = action.payload.pagination || _paginateDefault;
        });
    },
});

export const {
    // Detail
    // List
    setSort,
    setDataTable,
    setPaginateMetaData,
    setSelectedItem,
    setSelectedItems,
    // Common
    setDetailLayout,
    setShowDeleteButton,
    setFormSearch,
    handleBackProcessingTask,
    setMode,
    setKeywords,
    resetExportTaskState
} = exportTaskSlice.actions;

export default exportTaskSlice.reducer;
